import { calculateBudgetForProject } from "../../../../../planner/milestone/utils/budget.utils";

const FIXED_FEE_PLANNER_TYPES = new Set([
  "Fixed Fee Project",
  "Fixed Fee Deliverable",
]);

export const isFixedFeePlannerType = (plannerType) =>
  Boolean(plannerType && FIXED_FEE_PLANNER_TYPES.has(plannerType));

/** Hours columns are shown only when every linked project is Time + Materials. */
export const shouldShowHoursForProjectGroup = (projects) => {
  if (!Array.isArray(projects) || projects.length === 0) return false;
  return projects.every((p) => p?.plannerType === "Time + Materials");
};

/**
 * Project-level estimated cost and hours for health/financials,
 * aligned with single-project financials.
 */
export const getProjectBudgetForGroupRow = (
  deliverables,
  resources,
  plannerType,
  plannerServiceValue
) => {
  if (isFixedFeePlannerType(plannerType)) {
    const value = Number(plannerServiceValue) || 0;
    return { hours: 0, value };
  }
  return calculateBudgetForProject(deliverables, resources);
};
